// src/modules/app-views/crm/agendasService.js
// *******************************************************************************
// AGENDAS SERVICE
// *******************************************************************************
// Service layer for calendar events CRUD operations (agenda tab)
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import axiosService from 'services/axiosService';
import { API } from 'constants/Api';

// *******************************************************************************
// API METHODS
// *******************************************************************************

/**
 * Fetch all agenda events for the current user
 * @returns {Promise<Array>} Array of events
 */
async function fetchAll() {
  const [data] = await axiosService.get({
    url: API.AGENDAS.ALL,
    returnAsObject: false,
  });

  return data || [];
}

/**
 * Create or update an event (upsert)
 * @param {Object} data - Event data
 * @param {string} [data._id] - Event ID (if updating)
 * @returns {Promise<Object>} Created/updated event
 */
async function save(data) {
  const _id = data?._id;

  if (_id) {
    // Update existing
    const url = API.AGENDAS.URL.replace(':_id?', _id);
    const [response] = await axiosService.put({
      url,
      data,
      returnAsObject: true,
    });
    return response;
  }

  // Create new
  const url = API.AGENDAS.URL.replace(':_id?', '');
  const [response] = await axiosService.post({
    url,
    data,
    returnAsObject: true,
  });
  return response;
}

/**
 * Delete an event
 * @param {string} _id - Event ID
 * @returns {Promise<Object>} Delete result
 */
async function remove(_id) {
  const url = API.AGENDAS.URL.replace(':_id?', _id);
  const [response] = await axiosService.delete({
    url,
    returnAsObject: true,
  });
  return response;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
const agendasService = {
  fetchAll,
  save,
  remove,
};

export default agendasService;
